import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import candidateActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";


const candidateSagas = function* () {
  yield all([
    yield takeEvery(
      candidateActions.GET_FULL_CANDIDATE_DETAILS,
      getFullCandidateDetails
    ),
    yield takeEvery(
      candidateActions.GET_TICKETS_LIST_BY_CANDIDATE,
      getTicketsListByCandidate
    ),
    yield takeEvery(
      candidateActions.GET_UPLOAD_PERSONAL_DETAILS,
      getUploadDetails
    ),
    yield takeEvery(candidateActions.GET_SEARCH_CANDIDATE_DETAILS, getCandidateDetailsBySearch),
    yield takeEvery(candidateActions.CHECK_DUPLICATE_EMAIL_OR_MOBILENO, checkDuplicateEmailOrMobileno),
    yield takeEvery(candidateActions.GET_PROFILE_PERSONAL_DETAILS, getProfilePersonalDetails),
    yield takeEvery(candidateActions.UPDATE_CANDIDATE_DETAILS, updateCandidateDetails),
    yield takeEvery(candidateActions.GET_COURSE_NAME_FOR_DUMP, getCandidateForDumpFunc),
    yield takeEvery(candidateActions.GENERATE_DUMP_REQUEST, generateDumpSaga)

  ]);
};

const getFullCandidateDetails = function* (data) {
  const { payload } = data;
  const getcourseid = payload?.courseid || localStorage.getItem("courseid")
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/candidate/detail/${payload?.id}/${getcourseid}`)
    );
    yield put({
      type: candidateActions.SET_FULL_CANDIDATE_DETAILS,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {
    ;
  }
};

// function* generateDumpSaga(action) {
//   const rowId = action?.payload?.rowId;
//       yield put({
//     type: candidateActions.SET_PENDING_DUMP,
//     payload: { rowId, pending: true }
//   });
//     yield delay(4000);
//      yield put({
//     type: candidateActions.SET_PENDING_DUMP,
//     payload: { rowId, pending: false }
//   });
//      yield put({ type: candidateActions.GENERATE_DUMP_SUCCESS, payload: rowId });
//   // try {
//   //     const result = yield call(() =>
//   //     axios.get(
//   //       `${API_URL}/backoffice/course/getAllCourse/${rowId}`
//   //     )
//   //   );
//   //   if (result) {
//   //     if(result?.data?.statusCode === 200 && result?.data?.currentstate === "completed"){
//   //       yield put({
//   //         type: candidateActions.SET_DOWNLOAD_DUMP_URL,
//   //         payload: result?.data?.result?.downloadUrl ? result?.data?.result?.downloadUrl : [],
//   //       });
//   //       yield put({ type: candidateActions.SET_PENDING_DUMP, payload: false });
//   //       yield put({ type: candidateActions.GENERATE_DUMP_SUCCESS, payload: rowId });
//   //     } 

//   //     if(result?.data?.statusCode === 200 && result?.data?.currentstate === "pending"){
//   //     yield delay(2000);
//   //     yield put({ type: candidateActions.SET_PENDING_DUMP, payload: true });
//   //     } else if(result?.data?.statusCode === 200 && result?.data?.currentstate === "failed"){
//   //             yield put({ type: candidateActions.GENERATE_DUMP_FAILURE, payload: rowId });
//   //             yield put({ type: candidateActions.SET_PENDING_DUMP, payload: false });
//   //     } else if (result?.data?.statusCode === 204) {
//   //       yield put({ type: candidateActions.SET_PENDING_DUMP, payload: false });
//   //         yield put({
//   //           type: commonActions.SET_ALERT,
//   //           payload: {
//   //             status: "failed",
//   //             show: true,
//   //             message: result?.data?.message,
//   //           },
//   //         });
//   //         yield delay(2000);
//   //         yield put({
//   //           type: commonActions.SET_ALERT,
//   //           payload: { status: null, show: false, message: null },
//   //         });
//   //     }  else  if (result?.data?.statusCode === 400) {
//   //       yield put({ type: candidateActions.SET_PENDING_DUMP, payload: false });
//   //     yield put({ type: candidateActions.GENERATE_DUMP_FAILURE, payload: rowId });
//   //        yield put({
//   //           type: commonActions.SET_ALERT,
//   //           payload: {
//   //             status: "failed",
//   //             show: true,
//   //             message: result?.data?.message,
//   //           },
//   //         });
//   //         yield delay(2000);
//   //         yield put({
//   //           type: commonActions.SET_ALERT,
//   //           payload: { status: null, show: false, message: null },
//   //         });
//   //   }
//   //   }
//   // } catch (error) {
//   //   yield put({ type: candidateActions.SET_PENDING_DUMP, payload: false });
//   //   yield put({ type: candidateActions.GENERATE_DUMP_FAILURE, payload: rowId });
//   //    yield put({
//   //           type: commonActions.SET_ALERT,
//   //           payload: {
//   //             status: "failed",
//   //             show: true,
//   //             message: "Something went wrong.",
//   //           },
//   //         });
//   //         yield delay(2000);
//   //         yield put({
//   //           type: commonActions.SET_ALERT,
//   //           payload: { status: null, show: false, message: null },
//   //         });
//   // }
// }

function* generateDumpSaga(action) {
  const rowId = action?.payload?.rowId;
  const isRegenerate = action?.payload?.isRegenerate ? action?.payload?.isRegenerate : null;
  let firstCall = true;
  yield put({
    type: candidateActions.SET_PENDING_DUMP,
    payload: { rowId, pending: true }
  });
  try {
    while (true) {
      const result = yield call(() =>
        axios.post(`${API_URL}/backoffice/customer/check-status-for-dump-download/${rowId}`, {
          isRegenerate: firstCall ? isRegenerate : null,
        })
      );
      if (result?.data?.statusCode === 200) {
        const currentState = (result?.data?.generaterequeststatus || '').toLowerCase();
        if (currentState === 'completed') {
          const downloadUrl = result?.data?.result?.downloadUrl;
          yield put({ type: candidateActions.SET_DOWNLOAD_DUMP_URL, payload: { rowId, url: downloadUrl } });
          yield put({
            type: candidateActions.SET_PENDING_DUMP,
            payload: { rowId, pending: false }
          });
          yield put({
            type: candidateActions.GENERATE_DUMP_SUCCESS,
            payload: rowId
          });
          yield put({
            type: commonActions.SET_ALERT,
            payload: {
              status: "success",
              show: true,
              message: result?.data?.message,
            },
          });
          yield put({
            type: candidateActions.GET_COURSE_NAME_FOR_DUMP,
            payload: {}
          });
          yield delay(3000);
          yield put({
            type: commonActions.SET_ALERT,
            payload: {
              status: null,
              show: false,
              message: null,
            },
          });
          break;
        }

        if (currentState === 'failed') {
          yield put({
            type: candidateActions.GENERATE_DUMP_FAILURE,
            payload: rowId
          });
          yield put({
            type: candidateActions.SET_PENDING_DUMP,
            payload: { rowId, pending: false }
          });
          yield put({
            type: commonActions.SET_ALERT,
            payload: {
              status: "failed",
              show: true,
              message: result?.data?.message,
            },
          });
          yield put({
            type: candidateActions.GET_COURSE_NAME_FOR_DUMP,
            payload: {}
          });
          yield delay(3000);
          yield put({
            type: commonActions.SET_ALERT,
            payload: {
              status: null,
              show: false,
              message: null,
            },
          });
          break;
        }
      } else if (result?.data?.statusCode === 204) {
        yield put({
          type: candidateActions.GENERATE_DUMP_FAILURE,
          payload: rowId
        });
        yield put({
          type: candidateActions.SET_PENDING_DUMP,
          payload: { rowId, pending: false }
        });
        yield put({
          type: commonActions.SET_ALERT,
          payload: {
            status: "failed",
            show: true,
            message: result?.data?.message,
          },
        });
         yield put({
          type: candidateActions.GET_COURSE_NAME_FOR_DUMP,
          payload: {}
        });
        yield delay(3000);
        yield put({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
        break;
      }
      firstCall = false;
      yield delay(5000);
    }
  } catch (error) {
    yield put({
      type: candidateActions.GENERATE_DUMP_FAILURE,
      payload: rowId
    });
    yield put({
      type: candidateActions.SET_PENDING_DUMP,
      payload: { rowId, pending: false }
    });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Something went wrong",
      },
    });
    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  }
}


const getCandidateForDumpFunc = function* () {
  //  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  yield put({ type: commonActions.SET_TABLE_LOADER, payload: true });
  try {
    // code to fetch coursename
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/course/getAllCourse`
      )
    );
    if (result) {
      // console.log(result?.data?.result,"consoeld log result")
      //     if (Array.isArray(result?.data?.result)) {
      //   for (const row of result?.data?.result) {
      //     yield put({
      //       type: candidateActions.GENERATE_DUMP_REQUEST,
      //       payload: {
      //         rowId: row?.courseid,
      //         isRegenerate: row?.isRegenerate ? row?.isR,
      //       },
      //     });
      //   }
      // }
      yield put({
        type: candidateActions.SET_COURSE_NAME_FOR_DUMP,
        payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
      });

      yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
      yield put({ type: commonActions.SET_TABLE_LOADER, payload: false });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({ type: commonActions.SET_TABLE_LOADER, payload: false });
  } catch (err) {
    // alert("Something Went Wrong.")
    console.log(err, "error comsled")
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
    yield put({ type: commonActions.SET_TABLE_LOADER, payload: false });
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "failed",
        show: true,
        message: "Something went wrong.",
      },
    });
    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: null,
        show: false,
        message: null,
      },
    });
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  yield put({ type: commonActions.SET_TABLE_LOADER, payload: false });
};

const getTicketsListByCandidate = function* (data) {
  const { payload } = data;

  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/backoffice/grievance/ticket/candidate/${payload?.id}`
      )
    );
    yield put({
      type: candidateActions.SET_TICKETS_LIST_BY_CANDIDATE,
      payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
    });
  } catch (err) {
    ;
  }
};

const getUploadDetails = function* (data) {
  const { payload } = data;
  const courseid = localStorage.getItem("courseid")
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/backoffice/candidate/details/upload/${payload?.id}/${courseid}`)
    );
    if (result) {
      yield put({
        type: candidateActions.SET_UPLOAD_PERSONAL_DETAILS,
        payload: result?.data?.statusCode === 200 ? result?.data?.result : [],
      });
    }
  } catch (err) {
    ;
  }
};

const getCandidateDetailsBySearch = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() => axios.get(`${API_URL}/backoffice/candidatemanagement`, {
      params: {
        candidatename: payload?.candidatename,
        emailid: payload?.emailid,
        mobileno: payload?.mobileno,
        dob: payload?.dob,
        candidateid: payload?.data?.candidateid
      }
    }
    ));
    if (result) {
      let arr = result?.data?.result;
      let finalarr = arr?.map((val, i) => (
        {
          ...val,
          's.no': i + 1
        }))
      yield put({
        type: payload?.data?.candidateid ? candidateActions.SET_UPDATE_CANDIDATE_DETAILS : candidateActions.SET_SEARCH_CANDIDATE_DETAILS,
        payload: result?.data?.statusCode === 200 ? finalarr : []
      })
    }
  } catch (err) {
    ;
  }
}

const checkDuplicateEmailOrMobileno = function* (data) {
  const { payload } = data;
  const { setAndClearError } = payload;

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/candidate/check-duplicate`, payload?.data)
    );
    if (result?.data) {
      setAndClearError({ ...result?.data, type: payload?.data?.type });
    }
  } catch (err) {
  }
};

const getProfilePersonalDetails = function* (data) {
  const { payload } = data;

  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  try {
    const result = yield call(() =>
      axios.get(`${API_URL}/candidate/registration/${payload?.id}`)
    );
    if (result) {
      yield put({
        type: candidateActions.SET_PROFILE_PERSONAL_DETAILS,
        payload: result?.data?.result,
      });
    }
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  } catch (err) {
    ;
  }
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
};

const updateCandidateDetails = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() => axios.put(`${API_URL}/backoffice/candidatemanagement/${payload?.ssouserid}/${payload?.candidateid}`, {
      candidatename: payload?.candidatename,
      emailid: payload?.emailid,
      mobileno: payload?.mobileno,
      dob: payload?.dob
    }))
    if (result) {
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: result?.data?.statusCode === 200 ? "success" : "failed",
          show: true,
          message: result?.data?.message,
        },
      });
      yield delay(2000);
      yield put({
        type: commonActions.SET_ALERT,
        payload: {
          status: null,
          show: false,
          message: null,
        },
      });
    }
  } catch (err) {
    ;
  }
}

export default candidateSagas;
